import { useMemo } from 'react'

import { AppId } from '@inno-tools/container-bridge'
import { FullPageAppTemplate } from 'modules/app-registry/templates'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { DEFAULT_LANGUAGE } from 'shared/constants/Languages'
import { useNavigationContext, useUserContext } from 'shared/hooks'

import { useAvailableApps } from '../hooks/useAvailableApps'

export const EmailApp = () => {
  const { i18n } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const { user } = useUserContext()
  const { apps } = useAvailableApps()
  const { setAIAssistantConfig, setEmailAppUnreadMessagesCount } =
    useNavigationContext()

  const selectedLanguage = useMemo(
    () => i18n.language ?? DEFAULT_LANGUAGE,
    [i18n.language]
  )

  return (
    <FullPageAppTemplate
      appId={AppId.EMAIL}
      scope='email'
      envKey={apps[AppId.EMAIL].runtimeEnvKey}
      entryPath='./EmailApp'
      url={process.env.REACT_APP_EMAIL_APP_DEV_PATH}
      appName={apps[AppId.EMAIL].name}
      appProps={{
        user,
        initialPath: location.pathname,
        selectedLanguage,
        setAIAssistantConfig,
        setEmailAppUnreadMessagesCount,
        onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
          const { pathname } = location

          if (pathname !== nextPathname) {
            navigate(nextPathname)
          }
        }
      }}
    />
  )
}
